import React, { useCallback, useEffect, useState } from "react";
import { Modal, Toast, ToastContainer } from "react-bootstrap";
import CommomButton from "../../../components/common-button";
import { Cancel01Icon, CheckmarkBadge04Icon } from "../../../icons/icons";
import CommonFormLabel from "../../../components/common-form-label";
import SelectBox from "../../../components/select-box";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  cloneCustomerCampaign,
  fetchEvents,
} from "../../../store/eventsSlice";
import { useNavigate } from "react-router-dom";

const CloneCampaignModal = ({ show, onHide, campaignId, refetch, cloneCampaignStatus, userActive }) => {
  const [customers, setCustomers] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("toast-success");  
  const [clonedCampaignId, setClonedCampaignId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const authId = useSelector((state) => state.auth.user.id);  

  const fetchCustomers = useCallback(() => {
      dispatch(fetchEvents({ id : authId }))
        .unwrap()
        .then((res) => {
          setCustomers(res?.data || []);
        })
        .catch((err) => {
          console.error("Failed to fetch customers", err);
          setCustomers([]);
        });
    }, [dispatch, authId]);

  useEffect(() => {
    if (show && campaignId) {
      fetchCustomers();
      setClonedCampaignId(null);
    }
  }, [show, campaignId, fetchCustomers]);
  
  const initialValues = {
    customer: "",
  };

  const validationSchema = Yup.object().shape({
    customer: Yup.string().required("Customer is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await dispatch(
        cloneCustomerCampaign({
          campaignId,
          customer_id: values.customer,
        })
      ).unwrap();
  
      if (res.success) {
        setToastMessage(res.message || "Campaign cloned successfully");
        setToastVariant("toast-success");
        setShowToast(true);
        refetch?.();

        setClonedCampaignId(res.data?.id); 
        // Do NOT call onHide()
      } else {
        setToastMessage("Clone failed");
        setToastVariant("toast-danger");
        setShowToast(true);
      }
    } catch (err) {
      setToastMessage("Clone failed");
      setToastVariant("toast-danger");
      setShowToast(true);
    } finally {
      setSubmitting(false);
    }
  };
  
  const handleViewClone = () => {
    if (clonedCampaignId) {
      onHide(); 
      navigate(`/all-campaigns/view-campaign/${clonedCampaignId}`, {
      state: {
        campaing: {
          id: clonedCampaignId,
          status: "drafted", 
          is_active: userActive
        },
      },
    });
    }
  };

  return (
    <>
    <ToastContainer position="top-end" className="p-3">
    <Toast
      onClose={() => setShowToast(false)}
      show={showToast}
      delay={3000}
      autohide
      bg={toastVariant}
      className="position-fixed top-3 end-0 me-3 shadow-none"
    >
      <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
        <CheckmarkBadge04Icon
          width={18}
          height={18}
          color="#28c76f"
          strokeWidth="2"
        />
        <span className="text-capitalize">{toastMessage}</span>
      </Toast.Body>
    </Toast>
  </ToastContainer>

    <Modal
      show={show}
      centered
      dialogClassName="common-popup-dialog"
      contentClassName="common-popup-content"
      backdropClassName="common-popup-backdrop"
    >
      <Modal.Body className="common-popup-body">
        <div
          className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center  common-popup-colose-btn"
          onClick={onHide}
        >
          <Cancel01Icon
            width={16}
            height={16}
            color="#BCBBC1"
            strokeWidth="2.5"
          />
        </div>
        <div className="mb-4 text-center common-popup-heading">
          <h4 className="text-capitalize mb-2 fw-medium">Clone Campaign</h4>
          {/* <p>Add Request Credit</p> */}
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting, errors, touched }) => (
            <Form encType="multipart/form-data">
              <div>
                <div className="common-mb-space">
                  <CommonFormLabel title="Select Customer" />
                  <SelectBox
                    name="customer"
                    staticOption="Choose a Customer"
                    data={customers.map((customer) => ({
                      value: customer.id,
                      label: customer.name,
                    }))}
                    value={values.customer}  
                    onChange={(e) => setFieldValue("customer", e.target.value)}
                    isInvalid={touched.customer && errors.customer}
                  />
                  {touched.customer && errors.customer && (
                    <div className="text-danger mt-1">{errors.customer}</div>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 common-popup-btn">
                {clonedCampaignId ? (
                      <>
                  <CommomButton
                            title="View Cloned Campaign"
                            onClick={handleViewClone}
                            className="btn-primary btn-sm primary-shadow"
                            type="button"
                          />
                        <CommomButton
                          title="Close"
                          onClick={onHide}
                          className="btn-muted"
                          type="button"
                        />
                      </>
                    ) : (
                      <>
                        <CommomButton
                          title="Clone Campaign"
                    type="submit"
                    disabled={isSubmitting}
                    className="btn-primary primary-shadow"
                  />
                  <CommomButton
                    title="Cancel"
                    onClick={onHide}
                    className="btn-muted"
                    type="button"
                  />
                      </>
                    )}


                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default CloneCampaignModal;
